module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/consumer-magazine-online-e88e5211398a10a349ee2c8f0cafd0a7.png";